import { render, staticRenderFns } from "./ScreenshotsCarousel.vue?vue&type=template&id=7395314f&"
import script from "./ScreenshotsCarousel.vue?vue&type=script&lang=js&"
export * from "./ScreenshotsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotsCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports